import React              from 'react';
import { useTranslation } from 'react-i18next';

import Button    from '@mui/material/Button';
import Grid      from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import isBlank from 'utils/isBlank';

import PropTypes from 'prop-types';

/**
 * Might start with + and country code
 * And then number of length between 4 and 14
 */
const phoneNoRegex = /^(\+[1-9][0-9]{0,2})?[0-9]{4,14}$/;


export default function OrderCardsForm(props) {

  const { t } = useTranslation();

  const [branch, setBranch]                 = React.useState('');
  const [fullName, setFullName]             = React.useState('');
  const [phoneNo, setPhoneNo]               = React.useState('');
  const [product, setProduct]               = React.useState('');
  const [embossedName, setEmbossedName]     = React.useState('');
  const [layout, setLayout]                 = React.useState('');
  const [numberOfCards, setNumberOfCards]   = React.useState(1);
  const [additionalData, setAdditionalData] = React.useState('');

  const [fieldErrors, setFieldErrors] = React.useState({});

  function onSubmitPressed() {
    const requiredValidator = (val) => {
      if (isBlank(val)) {
        return t('fieldRequired');
      }
    }
    const moreThan0Validator = (val) => {
      if (isNaN(val) || val < 1) {
        return t('moreThan0');
      }
    }
    const phoneNoValidator = (val) => {
      if (!phoneNoRegex.test(val)) {
        return t('notAPhoneNumber');
      }
    }

    const validators = {
      default: [requiredValidator],
      numberOfCards: [requiredValidator, moreThan0Validator],
      cardReceiverPhoneNumber: [requiredValidator, phoneNoValidator],
      additionalInformation: [],
    };

    const toBeSubmitted = {
      branch:                  branch,
      cardReceiverFullName:    fullName,
      cardReceiverPhoneNumber: phoneNo,
      product:                 product,
      numberOfCards:           numberOfCards != null && numberOfCards.toString(), //required to be String
      embossedName:            embossedName,
      layout:                  layout,
      additionalInformation:   additionalData,
    };

    let allValid = true;
    const invalidFields = {};

    for (const key in toBeSubmitted) {
      const fieldValidators = validators[key] || validators.default;
      if (fieldValidators.length === 0) {
        continue; //No validation
      }

      for (const i in fieldValidators) {
        const validator = fieldValidators[i];
        const errMsg = validator(toBeSubmitted[key]);
        if (errMsg) {
          allValid = false;
          invalidFields[key] = errMsg;
          break;
        }
      }
    }
    setFieldErrors(invalidFields);
    if (!allValid)
      return;

    props.onSubmit(toBeSubmitted)
  }

  function preventNonDigits(evt) {
    const key    = evt.key;
    const parsed = parseInt(key);
    if (!isNaN(parsed))
      return;
    if (evt.ctrlKey)
      return;
    if (key.length === 1)
      evt.preventDefault();
  }

  function commonProps(fieldName, notRequired) {
    function clearError() {
      setFieldErrors(prevState => {
        const newState = { ...prevState };
        delete newState[fieldName];
        return newState;
      });
    }

    return {
      required:   !notRequired,
      error:      !!fieldErrors[fieldName],
      helperText: fieldErrors[fieldName] || ' ',
      onFocus:    clearError,
      disabled:   props.disabled
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          value={branch}
          label={t('branch')}
          onChange={evt => setBranch(evt.target.value)}
          {...commonProps('branch')}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          value={fullName}
          label={t('fullName')}
          onChange={evt => setFullName(evt.target.value)}
          {...commonProps('cardReceiverFullName')}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          value={phoneNo}
          label={t('phoneNo')}
          onChange={evt => {
            const value = evt.target.value.replaceAll(/[^+0-9]/g, '');
            setPhoneNo(value);
          }}
          inputProps={{
            maxLength: 13, //+ and country code and number //TODO ustalic jaki format
          }}
          {...commonProps('cardReceiverPhoneNumber')}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          value={product}
          label={t('product')}
          onChange={evt => setProduct(evt.target.value)}
          {...commonProps('product')}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          fullWidth
          value={embossedName}
          label={t('embossedName')}
          onChange={evt => setEmbossedName(evt.target.value)}
          {...commonProps('embossedName')}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          fullWidth
          value={layout}
          label={t('layout')}
          onChange={evt => setLayout(evt.target.value)}
          {...commonProps('layout')}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          fullWidth
          value={numberOfCards}
          label={t('numberOfCards')}
          onChange={evt => setNumberOfCards(evt.target.value)}
          type='number'
          onKeyDown={preventNonDigits}
          inputProps={{
            min: 1,
          }}
          {...commonProps('numberOfCards')}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          value={additionalData}
          label={t('additionalData')}
          onChange={evt => setAdditionalData(evt.target.value)}
          inputProps={{
            maxLength: 4096,
          }}
          {...commonProps('additionalInformation', true)}
        />
      </Grid>
      <Grid item xs={12}>
        <Button onClick={onSubmitPressed} disabled={props.disabled}>
          {t('placeOrder')}
        </Button>
      </Grid>
    </Grid>
  );
}

OrderCardsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};